import { useSelector } from "react-redux";

import { sendRequestToEmision } from "@/redux/actions/vida";
import { formatAmountThousand, addSpaceAfterNChar } from "@/utils/Utils";
import { encryptAES } from "@/utils/CryptographyUtils";
import { getCodeSecurity } from "@/utils/apiCanal";
import { useDispatch } from "react-redux";

export const useSendEmail = () => {
  const plans = useSelector((state) => state.plans);
  const userData = useSelector((state) => state.vida.userData);
  const planSelected = useSelector((state) => state.plans.planSelected);
  const adviser = useSelector((state) => state.vida.adviserConfig);
  const { selectedJob, company } = useSelector((state) => state.jobs);

  const dispatch = useDispatch();

  const sendEmail = async () => {
    const sumAssured = addSpaceAfterNChar(planSelected?.sumAssured?.text, 2);
    const savingTime = planSelected?.savingTime?.text;
    const returnPercentage = planSelected?.returnPercentage?.text;

    const replaceToEmail = {
      NAME: userData.names,
      PRODUCT: "Vida Ahorro con Devolución",
      CURRENCY: "S/",
      FRECUENCY_PAY: plans.nameFrequency,
      INSURED_AMOUNT: formatAmountThousand(sumAssured || ""),
      AMOUNT_TO_PAY: formatAmountThousand(plans.typeOfFinancing.pagoMensual),
      PAYMENT_TIME: `${savingTime || ""} años`,
      TOTAL_PERCENT_RETURN: returnPercentage || "0%",
      TOTAL_AMOUNT_RETURN: formatAmountThousand(
        Number(plans.typeOfFinancing.devolucionTotal).toFixed(2)
      ),
      email: getEmailToSend(userData.email),
    };

    const requestEmision = {
      correo: {
        templateExterno: "mail-purchase-confirmation-money-backguarantee",
        para: [replaceToEmail.email],
        template: "",
        camposDinamicos: encryptAES(
          JSON.stringify({
            nombres: replaceToEmail.NAME,
            producto: replaceToEmail.PRODUCT,
            monto_asegurado: `${replaceToEmail.INSURED_AMOUNT}`,
            pago_mensual: `${replaceToEmail.CURRENCY} ${replaceToEmail.AMOUNT_TO_PAY}`,
            plazo_ahorro: replaceToEmail.PAYMENT_TIME,
            porcentaje_devolucion: replaceToEmail.TOTAL_PERCENT_RETURN,
            devolucion_total: `${replaceToEmail.CURRENCY} ${replaceToEmail.TOTAL_AMOUNT_RETURN}`,
          }),
          getCodeSecurity(),
        ),
        de: "RIMAC Digital <rimacdigital@rimac.com.pe>",
        asunto: "¡Compra exitosa!",
      },
      ideTransaccion: planSelected.ideTransaccion,
      producto: "vida",
      origen: sessionStorage.getItem("canal") || "web",
      ocupacion: selectedJob?.value,
      correoPago: userData.email,
      tercero: {
        tipoDocumento:
          userData?.tipoDocumento?.toString() || userData?.typeDoc?.toString(),
        numeroDocumento: userData?.numeroDocumento || userData?.documento,
        correo: userData?.email || userData?.correo,
        nombres: userData.nombres,
        apellidos: `${userData.apellidoPaterno} ${userData.apellidoMaterno}`,
      },
      seguro: {
        prima: Number(plans.typeOfFinancing.pagoMensual).toFixed(2),
      }
    };

    if (company) {
      requestEmision.nombreEmpresa = company;
    }

    dispatch(sendRequestToEmision(requestEmision));
  };

  const getEmailToSend = (userEmail) => {
    let emailToSend = userEmail;
    if (adviser.hasOwnProperty("id")) {
      const adviserEmail = String(adviser.email).split(",");
      emailToSend = [...[userEmail], ...adviserEmail];
    }
    return emailToSend;
  };

  return { sendEmail };
};
